import angular = require("angular");

export class NotFoundController {

  constructor() {}


}



/** WEBPACK FOOTER **
 ** ./src/scripts/controllers/notFound.ts
 **/